const PROD_HOST = import.meta.env.PROD_HOST ?? "https://app.lumen.energy"
const STAGING_HOST = import.meta.env.STAGING_HOST ?? "https://staging.lumen.energy"
const DEV_HOST = import.meta.env.VITE_FLASK_FROM_STAGING
  ? STAGING_HOST
  : "http://localhost:5050"
const IS_CHROMATIC = Boolean(import.meta.env.IS_CHROMATIC)

const IS_PROD = window.location.origin.startsWith(PROD_HOST)
const IS_STAGING = window.location.origin.startsWith(STAGING_HOST)
const IS_DEV = import.meta.env.MODE === "development" && !(IS_PROD || IS_STAGING)
const IS_TEST = import.meta.env.MODE === "test"

function getHost() {
  if (IS_PROD) {
    return PROD_HOST
  } else if (IS_STAGING) {
    return STAGING_HOST
  } else {
    return "http://localhost:3000"
  }
}

const HOST = getHost()
const API_ORIGIN = IS_TEST ? "http://localhost" : IS_DEV ? DEV_HOST : ""
const MARKETING_ORIGIN = "https://www.getlumen.com"

export {
  HOST,
  PROD_HOST,
  STAGING_HOST,
  IS_PROD,
  IS_STAGING,
  IS_DEV,
  API_ORIGIN,
  IS_CHROMATIC,
  MARKETING_ORIGIN,
}
